export default {
    setImages(state, images) {
        state.images = images;
    }

}